/******************************* 流程数据连接 *******************************/
import request from "@/utils/request";

/**
 * @description 查询行政区划数据
 * @param {string} [id]
 */
export function getProvinceSelector(id = "-1") {
  return request({
    url: "/workflow/engine/common/selectorProvince",
    method: "post",
    data: { id },
  });
}

/**
 * @description 查询指定的行政区划数据
 * @param {string[]} ids
 */
export function getProvinceByIds(ids) {
  return request({
    url: "/workflow/engine/common/selectorAllProvinces",
    method: "post",
    data: { ids },
  });
}

/**
 * @description 查询用户类型
 */
export function selectUserType() {
  return request({
    url: `/workflow/engine/common/selectUserType`,
    method: "post",
  });
}
